import { render, staticRenderFns } from "./TwoCol2575Editor.vue?vue&type=template&id=4b626c2a&"
import script from "./TwoCol2575Editor.vue?vue&type=script&lang=js&"
export * from "./TwoCol2575Editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports